import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Auth, Storage } from "aws-amplify";
import { LambdaClient, InvokeCommand } from "@aws-sdk/client-lambda";
import config from "aws-exports";
import { UserTracerCore } from "./userTracerCore";
import { bootstrapNetworkHealthMonitor } from "./networkHealth";

const backendParts = config.aws_user_files_s3_bucket.split("-");
const instanceBackend = backendParts[backendParts.length - 1];
const instanceRegion = config.aws_project_region;
const USER_TRACER_CONFIG_PATH = "system/config/userTracerConfig.json";

async function fetchRemoteConfig() {
  try {
    const resp = await Storage.get(USER_TRACER_CONFIG_PATH, {
      level: "public",
      bucket: config.aws_user_files_s3_bucket,
      region: config.aws_project_region,
      download: true,
      cacheControl: "no-cache",
    });
    const raw = await resp?.Body?.text?.();
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    if (error?.name === "NoSuchKey" || error?.code === "NoSuchKey") return null;
    return null;
  }
}

async function shipBatchWithAuth(envelope) {
  const credentials = await Auth.currentCredentials();
  const lambda = new LambdaClient({
    credentials: Auth.essentialCredentials(credentials),
    region: instanceRegion,
  });
  const authUser = await Auth.currentAuthenticatedUser({ bypassCache: false }).catch(() => null);
  if (authUser) {
    userTracer.setUserContext(authUser);
  }
  const accessToken =
    authUser?.signInUserSession?.idToken?.jwtToken ||
    authUser?.signInUserSession?.accessToken?.jwtToken ||
    null;

  const payload = {
    body: JSON.stringify({
      target: "report-user-tracer",
      access_token: accessToken,
      userTracerBatch: envelope,
    }),
  };

  await lambda.send(
    new InvokeCommand({
      FunctionName: `instanceHandlerLight-${instanceBackend}`,
      InvocationType: "Event",
      Payload: JSON.stringify(payload),
    })
  );
}

export const userTracer = new UserTracerCore({
  sourceApp: "meaplatform",
  instanceBackend,
  instanceRegion,
  fetchRemoteConfig,
  shipBatch: shipBatchWithAuth,
});

export function bootstrapUserTracer() {
  userTracer.bootstrap();
}

export function bootstrapNetworkHealth() {
  bootstrapNetworkHealthMonitor();
}

export function UserTracerRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    userTracer.captureRoute(`${location.pathname}${location.search}${location.hash}`);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
